export class PaymentItem {
    constructor({Amount, Description, ID, PaymentType, Branch_ID, Partner_ID}) {
        this.Amount = Amount;
        this.Description = Description;
        this.ID = ID;
        this.PaymentType = PaymentType;
        this.Branch_ID = Branch_ID;
        this.Partner_ID = Partner_ID;
    }
}
